import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { array, number, func } from 'prop-types';
import { startSetOfferNews } from '../../actions/offers';
import Card from '../Card/Card';
import NewsList from '../News/NewsList';

class OfferNews extends Component {
  static propTypes = {
    news: array.isRequired,
    offerId: number,
    startSetOfferNews: func.isRequired,
  };

  static defaultProps = {
    news: [],
  };

  componentDidMount() {
    const { offerId } = this.props;
    this.props.startSetOfferNews(offerId, { limit: 6 });
  }

  render() {
    const { news, offerId } = this.props;

    return (
      <div className="offer-news offer-card">
        <Card>
          <div className="offer-news-header">
            <p className="offer-news-title">
              <FormattedMessage id="offer.news.title" defaultMessage="Offer News" />
            </p>
            <Link className="btn btn-light btn-sm" to={`/offers/${offerId}/news`}>
              <FormattedMessage id="offer.news.all" defaultMessage="All offer's news" />
            </Link>
          </div>
          <NewsList news={news} inOffer />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  news: state.offers.news,
});

const mapDispatchToProps = (dispatch) => ({
  startSetOfferNews: (offerId, params) => dispatch(startSetOfferNews(offerId, params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OfferNews);
